import React from 'react';
import AboutPageBuilder from './AboutPageBuilder';

const ApplicationsPageBuilder = () => (
  <AboutPageBuilder
    endpoint="/admin/applications-page"
    pageTitle="Applications Builder"
    viewPath="/applications"
    viewLabel="View Applications"
    saveLabel="Save Applications"
    loadErrorMessage="Failed to load Applications layout."
    saveErrorMessage="Failed to save Applications layout."
    saveSuccessMessage="Applications page updated."
    loadingMessage="Loading Applications editor..."
    unavailableMessage="Applications layout unavailable."
  />
);

export default ApplicationsPageBuilder;
